export const MAX_RIDE_NAME_LENGTH = 120;

/** Validates a rider's name using the limit shared by video services. */
export function normalizeRideName(value: string): string {
  const name = value.replace(/\s+/gu, ' ').trim();
  if (!name) throw new Error('Enter a trace name.');
  if (name.length > MAX_RIDE_NAME_LENGTH) {
    throw new Error(`Use ${MAX_RIDE_NAME_LENGTH} characters or fewer.`);
  }
  if (/[\u0000-\u001f\u007f]/u.test(name)) {
    throw new Error('Remove special control characters from the name.');
  }
  return name;
}
